import React from 'react';
import { useState } from 'react';

const Where2ExitHe = () => {
   const [lastUpdated] = useState('13 באפריל, 2025');

   // Simple inline styles for responsiveness with RTL support
   const styles = {
      container: {
         maxWidth: '1200px',
         margin: '0 auto',
         padding: '20px',
         fontFamily: 'Arial, sans-serif',
         direction: 'rtl',
         textAlign: 'right',
      },
      header: {
         textAlign: 'center',
         marginBottom: '40px',
      },
      title: {
         fontSize: '32px',
         color: '#1976d2',
         marginBottom: '16px',
         fontWeight: 'bold',
      },
      date: {
         fontSize: '16px',
         color: '#666',
         marginBottom: '16px',
      },
      section: {
         marginBottom: '32px',
         backgroundColor: 'white',
         borderRadius: '8px',
         padding: '24px',
         boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
      },
      sectionTitle: {
         fontSize: '24px',
         color: '#1976d2',
         marginBottom: '16px',
         fontWeight: 'bold',
      },
      paragraph: {
         fontSize: '16px',
         lineHeight: 1.6,
         color: '#333',
         marginBottom: '16px',
      },
      list: {
         marginRight: '24px',
         marginBottom: '16px',
      },
      listItem: {
         fontSize: '16px',
         lineHeight: 1.6,
         color: '#333',
         marginBottom: '8px',
      },
      footer: {
         textAlign: 'center',
         marginTop: '40px',
         paddingTop: '20px',
         borderTop: '1px solid #eee',
         color: '#666',
      },
   };

   // Adding some basic media query responsiveness
   if (window.innerWidth <= 768) {
      styles.container.padding = '16px';
      styles.header.marginBottom = '24px';
      styles.title.fontSize = '24px';
      styles.sectionTitle.fontSize = '20px';
      styles.paragraph.fontSize = '14px';
      styles.listItem.fontSize = '14px';
      styles.section.padding = '16px';
      styles.section.marginBottom = '24px';
   }

   return (
      <div style={styles.container}>
         <header style={styles.header}>
            <h1 style={styles.title}>מדיניות פרטיות</h1>
            <p style={styles.date}>עודכן לאחרונה: {lastUpdated}</p>
         </header>

         <section style={styles.section}>
            <h2 style={styles.sectionTitle}>מבוא</h2>
            <p style={styles.paragraph}>
               ברוכים הבאים למדיניות הפרטיות של אפליקציית Where2Exit. אפליקציה זו מסייעת למשתמשי הרכבת הקלה האדומה (קו R1) במציאת היציאה הטובה ביותר מתחנות הרכבת הקלה.
               מסמך זה מסביר כיצד האפליקציה מטפלת במידע שלכם ומגינה על הפרטיות שלכם.
               אנו מכבדים את פרטיותכם ומחויבים לשקיפות מלאה לגבי השימוש במידע. אנא קראו את מדיניות הפרטיות הזו בעניות.
            </p>
         </section>

         <section style={styles.section}>
            <h2 style={styles.sectionTitle}>מידע שהאפליקציה אוספת</h2>
            <p style={styles.paragraph}>Where2Exit אוספת את המידע הבא כדי לספק לכם שירות מותאם אישית:</p>
            <ul style={styles.list}>
               <li style={styles.listItem}><strong>נתוני מיקום:</strong> המיקום הנוכחי שלכם (רק כאשר אתם מאשרים) כדי למצוא את התחנה הקרובה אליכם ולהמליץ על יציאה מתאימה.</li>
               <li style={styles.listItem}><strong>יעדי חיפוש:</strong> המקומות שאתם מחפשים נשמרים באופן מקומי במכשיר לצורך היסטוריית חיפושים.</li>
               <li style={styles.listItem}><strong>העדפות נגישות:</strong> אם בחרתם במסלולים נגישים, העדפה זו נשמרת באופן מקומי.</li>
            </ul>
            <p style={styles.paragraph}><strong>חשוב לדעת:</strong> כל המידע נשמר רק במכשיר שלכם ואינו נשלח לשרתים חיצוניים.</p>
         </section>

         <section style={styles.section}>
            <h2 style={styles.sectionTitle}>כיצד אנו משתמשים במידע</h2>
            <p style={styles.paragraph}>המידע שנאסף משמש אך ורק למטרות הבאות:</p>
            <ul style={styles.list}>
               <li style={styles.listItem}><strong>מציאת תחנות קרובות:</strong> נתוני המיקום עוזרים למצוא את תחנת הרכבת הקלה הקרובה אליכם.</li>
               <li style={styles.listItem}><strong>המלצה על יציאות:</strong> חישוב המסלול הקצר ביותר מהיציאה המתאימה ליעד שלכם.</li>
               <li style={styles.listItem}><strong>שיפור חוויית המשתמש:</strong> שמירת חיפושים קודמים לנוחות השימוש.</li>
               <li style={styles.listItem}><strong>נגישות:</strong> התאמת ההמלצות למשתמשים עם צרכי נגישות מיוחדים.</li>
            </ul>
            <p style={styles.paragraph}><strong>לא נעשה שימוש במידע למטרות שיווק, פרסום או מכירה לצדדים שלישיים.</strong></p>
         </section>

         <section style={styles.section}>
            <h2 style={styles.sectionTitle}>אחסון נתונים ואבטחה</h2>
            <p style={styles.paragraph}>
               <strong>אחסון מקומי בלבד:</strong> כל המידע נשמר אך ורק במכשיר שלכם. אין לנו שרתים שאוספים או מאחסנים את המידע האישי שלכם.
            </p>
            <p style={styles.paragraph}>
               <strong>אבטחת המידע:</strong> המידע מוגן על ידי מערכת האבטחה של iOS ולא נגיש לאפליקציות אחרות או לצדדים שלישיים.
            </p>
            <p style={styles.paragraph}>
               <strong>מחיקת נתונים:</strong> תוכלו למחוק את היסטוריית החיפושים בכל עת מתוך האפליקציה, או למחוק את האפליקציה כולה כדי להסיר את כל הנתונים.
            </p>
         </section>

         <section style={styles.section}>
            <h2 style={styles.sectionTitle}>שירותי Apple ושירותי צד שלישי</h2>
            <p style={styles.paragraph}>
               האפליקציה משתמשת בשירותים הבאים של Apple:
            </p>
            <ul style={styles.list}>
               <li style={styles.listItem}><strong>MapKit:</strong> לתצוגת מפות ונתוני מיקום. Apple עשויה לעבד בקשות חיפוש לפי מדיניות הפרטיות שלה.</li>
               <li style={styles.listItem}><strong>Core Location:</strong> לקבלת נתוני מיקום (רק באישורכם).</li>
               <li style={styles.listItem}><strong>MKLocalSearch:</strong> לחיפוש כתובות ומקומות.</li>
            </ul>
            <p style={styles.paragraph}>
               <strong>חשוב לדעת:</strong> אנו לא משתמשים בכלי מעקב, אנליטיקס או פרסום של צדדים שלישיים. האפליקציה לא אוספת נתוני שימוש למטרות שיווק.
            </p>
         </section>

         <section style={styles.section}>
            <h2 style={styles.sectionTitle}>הזכויות שלכם</h2>
            <p style={styles.paragraph}>מאחר שכל המידע נשמר מקומית במכשיר שלכם, יש לכם שליטה מלאה על הנתונים:</p>
            <ul style={styles.list}>
               <li style={styles.listItem}><strong>בקרת מיקום:</strong> תוכלו לאפשר או לחסום גישת מיקום דרך הגדרות iOS בכל עת.</li>
               <li style={styles.listItem}><strong>מחיקת היסטוריה:</strong> מחיקת חיפושים קודמים מתוך האפליקציה באופן מידי.</li>
               <li style={styles.listItem}><strong>הגדרות נגישות:</strong> שינוי העדפות נגישות בכל עת.</li>
               <li style={styles.listItem}><strong>מחיקה מלאה:</strong> הסרת האפליקציה מוחקת את כל הנתונים באופן סופי.</li>
            </ul>
            <p style={styles.paragraph}>
               <strong>אין צורך בבקשות מיוחדות:</strong> מאחר שאין לנו גישה לנתונים שלכם, תוכלו לנהל אותם באופן עצמאי לחלוטין.
            </p>
         </section>

         <section style={styles.section}>
            <h2 style={styles.sectionTitle}>גיל משתמשים</h2>
            <p style={styles.paragraph}>
               האפליקציה מיועדת לכלל הציבור וניתנת לשימוש על ידי משתמשים מכל הגילאים. 
               איננו אוספים מידע אישי ממשתמשים מתחת לגיל 13, ומשתמשים צעירים מעודדים להשתמש באפליקציה בליווי הורים.
            </p>
         </section>

         <section style={styles.section}>
            <h2 style={styles.sectionTitle}>נתוני תחבורה ציבורית</h2>
            <p style={styles.paragraph}>
               מידע על תחנות הרכבת הקלה, יציאות ונתוני הנגישות מבוסס על מקורות ציבוריים וחקר עצמאי. 
               מידע זה אינו מחובר לנתונים אישיים שלכם ונמצא בטעינה מקומית באפליקציה.
            </p>
         </section>

         <section style={styles.section}>
            <h2 style={styles.sectionTitle}>שינויים במדיניות הפרטיות הזו</h2>
            <p style={styles.paragraph}>
               אנו עשויים לעדכן את מדיניות הפרטיות שלנו מעת לעת. נודיע לכם על כל שינוי על ידי פרסום מדיניות הפרטיות החדשה בדף זה ועדכון התאריך "עודכן לאחרונה" בחלק העליון של מדיניות פרטיות זו.
               מומלץ לכם לעיין במדיניות פרטיות זו מעת לעת לכל שינוי. שינויים במדיניות פרטיות זו יהיו בתוקף כאשר הם מפורסמים בדף זה.
            </p>
         </section>

         <section style={styles.section}>
            <h2 style={styles.sectionTitle}>צרו קשר</h2>
            <p style={styles.paragraph}>
               אם יש לכם שאלות כלשהן לגבי מדיניות פרטיות זו, אנא צרו איתנו קשר:
            </p>
            <ul style={styles.list}>
               <li style={styles.listItem}>בדוא"ל: haggaimagen87@gmail.com</li>
            </ul>
         </section>

         <footer style={styles.footer}>
            <p style={styles.paragraph}>© 2025 Where2Exit. כל הזכויות שמורות.</p>
         </footer>
      </div>
   );
};

export default Where2ExitHe;